(function () {

  // ── Remove bundle on button click ─────────────────────────────────────────
  document.addEventListener('mousedown', async (event) => {
    const button = event.target.closest('[data-bundle-remove]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const dealBlock = button.dataset.bundleRemove;
    button.disabled = true;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const updates = {};
      cart.items
        .filter(item => item.properties && item.properties['_deal_block'] === dealBlock)
        .forEach(item => { updates[item.key] = 0; });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      window.location.reload();


    } catch (error) {
      console.error('Bundle remove failed:', error);
      button.disabled = false;
    }
  }, true);

  // ── Hide duplicate bundle rows after every re-render ──────────────────────
  function hideDuplicateBundleRows() {
    const seenDealBlocks = new Set();
    document.querySelectorAll('.cart-items__bundle-row').forEach(row => {
      const btn = row.querySelector('[data-bundle-remove]');
      if (!btn) return;
      const dealBlock = btn.dataset.bundleRemove;
      if (seenDealBlocks.has(dealBlock)) {
        row.style.display = 'none';
      } else {
        seenDealBlocks.add(dealBlock);
        row.style.display = '';
      }
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', hideDuplicateBundleRows);

  // Watch for morphSection re-renders and re-apply
  function attachObserver() {
    const cartWrapper = document.querySelector('cart-items-component');
    if (cartWrapper) {
      new MutationObserver(() => setTimeout(hideDuplicateBundleRows, 50))
        .observe(cartWrapper, { childList: true, subtree: true });
    } else {
      setTimeout(attachObserver, 300);
    }
  }

  attachObserver();

})();

